import base from '../dr-base'
import drSnippet from './dr-snippet-editor.vue'

const schema = {
  $Type: 'dr-snippet-editor',
  name: 'Additional properties',
  group: 'Common widgets',
  ...base,
  allowInToolbox: false,
  properties: {
    AdditionalProperties: {
      name: 'vuetifyWidgets.dr-snippet-editor.additionalProperties',
      type: 'object',
      component: 'dr-snippet-editor'
    }
  }
}

export default {
  schema,
  component: drSnippet
}